import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CoreService } from '../../../../services';

// Define a service holding the language. You probably already have one if your app is i18ned. Or you could also use the Angular LOCALE_ID value
@Injectable()

export class I18n {
  constructor(private indParam: CoreService) { }

  language: string = this.indParam.AppParams.culture === 'fr-FR' ? 'fr' : this.indParam.AppParams.culture === 'en-GB' ? 'en' : 'fr';
}

// Define custom service providing the months and weekdays translations
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  I18N: any;

  constructor(
    private _i18n: I18n,
    private indParam: CoreService
  ) {
    super();
    if (this.indParam.AppParams.culture === 'fr-FR') {
      this.I18N = {
        'fr': {
          weekdays: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
          months: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Déc'],
        }
      };
    }
    if (this.indParam.AppParams.culture === 'en-GB') {
      this.I18N = {
        'en': {
          weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
          months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        }
      };
    }
  }

  getWeekdayShortName(weekday: number): string {
    return this.I18N[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return this.I18N[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
  getDayAriaLabel(date: NgbDateStruct): string {
    let dt: string = '';
    if (this.indParam.AppParams.culture === 'fr-FR') {
      dt = `${date.day}/${date.month}/${date.year}`;
    }
    if (this.indParam.AppParams.culture === 'en-GB') {
      dt = `${date.year}/${date.month}/${date.day}`;
    }
    return dt;
  }
}



@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {

  constructor(
    private indParam: CoreService
  ) {
    super();
  }

  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts: Array<string> = value.trim().split('-');
      if (dateParts.length === 1 && isNumber(dateParts[0])) {
        return { day: toInteger(dateParts[0]), month: 0, year: 0 };
      } else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
        return { day: toInteger(dateParts[0]), month: toInteger(dateParts[1]), year: 0 };
      } else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
        return { day: toInteger(dateParts[0]), month: toInteger(dateParts[1]), year: toInteger(dateParts[2]) };
      }
    }
    return <any>null;
  }

  format(date: NgbDateStruct): string {
    let dt: string = '';
    if (this.indParam.AppParams.culture === 'fr-FR') {
      dt = date ?
        `${isNumber(date.day) ? padNumber(date.day) : ''}/${isNumber(date.month) ? padNumber(date.month) : ''}/${date.year}` :
        '';
    }
    if (this.indParam.AppParams.culture === 'en-GB') {
      dt = date ?
        `${date.year}/${isNumber(date.month) ? padNumber(date.month) : ''}/${isNumber(date.day) ? padNumber(date.day) : ''}` :
        '';
    }
    return dt;
  }
}


function padNumber(value: number): string {
  if (isNumber(value)) {
    return `0${value}`.slice(-2);
  } else {
    return '';
  }
}

function isNumber(value: any): boolean {
  return !isNaN(toInteger(value));
}

function toInteger(value: any): number {
  return parseInt(`${value}`, 10);
}
